<template>
  <!-- <div v-if="quickNavAnchorLinks && quickNavAnchorLinks.length > 0"> -->
  <ul class="quick-nav-links">
    <template v-for="(quickNavAnchorLink, index) in quickNavAnchorLinks" :key="`quick-nav-link-${index}`">
      <li v-if="quickNavAnchorLink.isVisible">
        <!-- <a :href="quickNavAnchorLink.linkTo">{{ quickNavLink.displayName }}</a> -->
        <a @click.prevent="navigateTo(quickNavAnchorLink.linkTo)">{{ quickNavAnchorLink.displayName }}</a>
      </li>
    </template>
  </ul>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'QuickNavAnchorLinks',
  props: {
    /**
     * Array of of quick nav link objects. Format of each object:
     *  {
     *    displayName: String,
     *    linkTo: String,
     *    isVisible: Boolean,
     *  }
     */
    quickNavAnchorLinks: {
      type: Array,
      required: true,
    },
  },

  methods: {
    navigateTo(linkTo) {
      this.$emit('navigateTo', linkTo);
    },
  },
};
</script>

<style lang="scss" scoped></style>
